import store from 'store2';

const CJ_DATA_KEY = `cjData`;

/**
 * Data from affiliate partner passed in query parameters
 * @see https://developers.cj.com/docs/data-imports/action-data
 */
type CjData = {
	AID?: string;
	PID?: string;
	SID?: string;
	cjevent?: string;
};

export const clearCjData = (): void => {
	store.local.remove(CJ_DATA_KEY);
};
export const getCjData = (): CjData | undefined => store.local.get(CJ_DATA_KEY);

export const setCjData = (cjData): void => {
	store.local.set(CJ_DATA_KEY, cjData);
};
